import request from '@/utils/request'

// 获取小区推荐列表
export function getCommunityRecommendList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recommend.listCommunityRecommend',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存小区推荐
export function saveCommunityRecommend(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recommend.saveCommunityRecommend',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新小区推荐
export function updateCommunityRecommend(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recommend.updateCommunityRecommend',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除小区推荐
export function deleteCommunityRecommend(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recommend.deleteCommunityRecommend',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询管理员店铺
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询家政服务
export function queryAdminServ(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.queryAdminServ',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}